import React from 'react';
import {
  SEO,
  BikiniHero,
  BikiniWaxCostDivider,
  HowBikiniWork,
  SectionDivider,
  LHRIdealForBikini,
} from '../../components';
import { graphql } from 'gatsby';

function BikiniPage() {
  return (
    <main id='bikini-page'>
      <BikiniHero />
      <BikiniWaxCostDivider />
      <HowBikiniWork />
      <SectionDivider />
      <LHRIdealForBikini />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Bikini Area Laser Hair Removal | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Get ready for summer with our bikini laser hair removal! Say goodbye to unwanted hair and hello to smooth, beach-ready skin. Book your session today!'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default BikiniPage;
